<template>
  <span>
    <button
      v-if="!isEdit"
      class="btn btn-primary-small rounded-pill px-5 py-3"
      v-b-modal.agency-modal
    >
      <i class="fa fa-plus fa-lg mr-3"></i>
      {{ trans("agencies.button_add_agency") }}
    </button>
    <button
      v-if="isEdit"
      class="btn btn-primary-outline"
      v-b-modal.agency-modal
    >{{ trans("agencies.button_edit_agency") }}</button>
    <b-modal
      id="agency-modal"
      size="lg"
      hide-header
      @show="loadModal"
      @hidden="resetModal"
      body-class="pb-5 pt-0"
    >
      <template v-slot:default>
        <div class="row bg-light-blue">
          <div class="col-lg-12">
            <div class="p-3" v-if="!isEdit">
              <h3 class="font-green">{{ trans("agencies.modal_add_agency_title") }}</h3>
              <p class="mb-2">
                {{
                trans("agencies.modal_add_agency_subtitle")
                }}
              </p>
            </div>
            <div class="p-3" v-if="isEdit">
              <h3 class="font-green">{{ trans("agencies.modal_edit_agency_title") }}</h3>
              <p class="mb-2">
                {{
                trans("agencies.modal_edit_agency_subtitle")
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <form class="px-3 py-4">
              <div class="form-group">
                <label>
                  {{
                  trans("agencies.modal_agency_name")
                  }}
                </label>
                <input
                  v-model="agency.name"
                  type="text"
                  class="form-control form-control-lg bg-gray border-0"
                  :class="{
                                        'is-invalid': $v.agency.name.$error
                                    }"
                />
              </div>
              <div class="form-group">
                <label>
                  {{
                  trans("agencies.modal_agency_description")
                  }}
                </label>
                <textarea
                  v-model="agency.description"
                  class="form-control bg-gray border-0"
                  rows="4"
                ></textarea>
              </div>
            </form>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn mr-3"
          @click="cancel()"
        >{{ trans("agencies.modal_agency_cancel") }}</button>
        <button
          v-if="!isEdit"
          type="button"
          class="btn btn-primary px-5"
          @click="handleOk()"
        >{{ trans("agencies.modal_add_agency_ok") }}</button>
        <button
          v-if="isEdit"
          type="button"
          class="btn btn-primary px-5"
          @click="handleOk()"
        >{{ trans("agencies.modal_edit_agency_ok") }}</button>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
    props: ["edit", "agency_id"],
    data() {
        return this.initData();
    },
    validations: {
        agency: {
            name: { required }
        }
    },
    mounted() {
        if (this.edit == "true") {
            this.isEdit = true;
            // this.loadEdit(this.agency_id);
        }
    },
    methods: {
        initData() {
            return {
                agency: {
                    name: "",
                    description: ""
                },
                isEdit: false
            };
        },
        handleOk() {
            if (this.isEdit) {
                this.submit_update();
            } else {
                this.submit_store();
            }
        },
        async submit_store() {
            let loader = this.$loading.show();
            this.$v.$touch();
            if (this.$v.$invalid) {
                loader.hide();
            } else {
                try {
                    const { data } = await axios.post(
                        route("api.agencies.store"),
                        {
                            agency: this.agency
                        }
                    );
                    loader.hide();
                    this.successSwal();
                    this.$bvModal.hide("agency-modal");
                    if (typeof window.reloadTable == "function") {
                        reloadTable();
                    }
                } catch (e) {
                    loader.hide();
                    this.errorPopup(e.response.data.message);
                }
            }
        },
        async submit_update() {
            let loader = this.$loading.show();
            this.$v.$touch();
            if (this.$v.$invalid) {
                loader.hide();
            } else {
                try {
                    const { data } = await axios.put(
                        route("api.agencies.update", this.agency.id),
                        {
                            agency: this.agency
                        }
                    );
                    location.reload();
                } catch (e) {
                    loader.hide();
                    this.errorPopup(e.response.data.message);
                }
            }
        },
        async loadEdit(id) {
            let loader = this.$loading.show();
            try {
                const { data } = await axios.get(
                    route("api.agencies.show", id)
                );
                this.agency = data;
                loader.hide();
            } catch (e) {
                loader.hide();
                this.errorPopup(e.response.data.message);
            }
        },
        resetModal() {
            this.agency = this.initData().agency;
            this.$v.$reset();
        },
        loadModal() {
            if (this.edit == "true") {
                this.loadEdit(this.agency_id);
            }
        }
    }
};
</script>
